export function useFile() {
    const getFileFromUrl = async (url: string) => {
        const response = await fetch(url)
        const data = await response.blob()

        return new File([data], url.split('/').pop() ?? '', {
            type: data.type,
        })
    }
    const validateImageUrl = (url: string) => {
        return new Promise<{ url: string, message: string }>((resolve, reject) => {
            const timeout = 5000
            const img: HTMLImageElement = new Image()
            let timer: NodeJS.Timeout | null = null

            img.onerror = img.onabort = () => {
                timer && clearTimeout(timer)
                reject({ url, message: 'No image found and that URL!' })
            }

            img.onload = () => {
                timer && clearTimeout(timer)
                resolve({ url, message: 'Success!' })
            }

            timer = setTimeout(() => {
                reject({ url, message: 'Destination could not be reached!' })
            }, timeout)
            img.src = url
        })
    }

    return {
        getFileFromUrl,
        validateImageUrl,
    }
}
